import PropTypes from "prop-types"

const NewActionBar = ({ children }) => (
  <div className="flex gap-4 my-4 px-8 py-2 items-center flex-wrap">
    {children}
  </div>
)
NewActionBar.propTypes = {
  children: PropTypes.node,
}
export default NewActionBar
